import * as React from 'react';
import {
  FileSpreadsheet,
  FileText,
  FileType,
  Image as ImageIcon,
  Presentation,
} from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * Lucide-based file icons matching frontend workops-icons categories (Word add-in has no /public/icons).
 */
export function FileTypeIcon({ type, size = 16, className = '' }: { type: string; size?: number; className?: string }) {
  const t = type.toLowerCase();
  if (t === 'pdf') {
    return <FileType className={cn('text-red-500', className)} size={size} strokeWidth={1.75} />;
  }
  if (['xls', 'xlsx', 'csv', 'excel'].includes(t)) {
    return <FileSpreadsheet className={cn('text-emerald-600', className)} size={size} strokeWidth={1.75} />;
  }
  if (['ppt', 'pptx'].includes(t)) {
    return <Presentation className={cn('text-orange-500', className)} size={size} strokeWidth={1.75} />;
  }
  if (['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg'].includes(t)) {
    return <ImageIcon className={cn('text-violet-500', className)} size={size} strokeWidth={1.75} />;
  }
  return <FileText className={cn('text-blue-600', className)} size={size} strokeWidth={1.75} />;
}
